export const CUSTOM_SUB_FEATURES = {
  Login: "login",
  Register: "register",
  ForgotPassword: "forgot-password",
  ResetPassword: "reset-password",
  VerifyEmail: "verify-email",
  Statistics: "statistics",
} as const;
